export default {
  namespaced: true,
  intelbras: {
    title: "Intelbras",
    name: "Name",
    panel_model: "Panel Model",
    panel: "Panel",
    panels: "Panels",
    host: "Host",
    port: "Port",
    client_password: "Client Password",
    remote_control_password: "Remote Control Password",
    listening_port: "Listening Port",
    facilities: "Facilities",
    event_code: "Event Code",
    alarm_type_sbo: "Alarm Type (SBO)",
    description: "Description",
    zone: "Zone",
    num_conact_id: "Contact ID Account Number",
    creation_date: "Creation Date",
    date: "Date",
    masterAccounts: "master accounts",
    masterAccount: "master account",
    first_name: "first name",
    last_name: "last name",
    link: "link",
    username: "username",
    token: "token",
    password: "password",
    token_expired: "token expiration",
    email: "email",
    sites: "sites",
    site: "site",
    address: "address",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "timezone",
    profile: "profile",
    profiles: "profiles",
    calendar: "calendar",
    serialNumber: "serial number",
    actions: "actions",
    schemaTypes: "schema types",
    schema_type: "schema type",
    display_name: "display name",
    id: "id",
    devices: "devices",
    gateway_id: "gateway id",
    schema_actions: "schema actions",
    typeAlarm: "alarm type",
    typeAlarms: "alarm types",
    priority: "priority",
    dispatchAlarm: "dispatchAlarm",
    alarms: "alarms",
    state: "state",
    creation_time: "creation time",
    units: "units",
    center: "center",
    sector: "sector",
    device: "device",
    schemaEvent: "event",
    time: "time",
    logs: "logs",
    channel: "channel",
    name_panel: "panel name",
    events: "events",
    syncCorrectly: "synchronized correctly",
    status: "Status",
    instance_host: "Instance Host",
    rules: "Rules",
    code: "Code",
    event: "Event",
    event_id: "Event ID",
    value: "Value",
    zones_pgm: "Zone / PGM",
    pgm_output: "PGM / Output",
    partition: "Partition",
    alias: "Alias",
    syncDevices: "Sync devices",
    syncing: "Syncing",
    withoutProfile: "The panel does not have a profile assigned",
    reconnect: "Reconnect",
    rebuild: "Restart",
    profile_name: "Profile Name",
    type: "Type",
    active: "Active",
    activate: "Activate",
    deactivate: "Deactivate",
    close: "Close",
    open: "Open",
    bypass: "Bypass",
    enable: "Enable",
    panelOffline: "Panel is offline",
    panelStatusArmed: "Armed",
    panelStatusDisarmed: "Disarmed",
    panelStatusOffline: "Offline",
    arm: "Arm",
    disarm: "Disarm",
    arming: "Arming",
    disarming: "Disarming",
    armedCorrectly: "Armed correctly",
    disarmedCorrectly: "Disarmed correctly",
    uuid: "UUID",
    connected: "Connected",
    disconnected: "Disconnected",
  }
}
